import { render, staticRenderFns } from "./orderSetting.vue?vue&type=template&id=12ed9f1e&scoped=true&"
import script from "./orderSetting.vue?vue&type=script&lang=js&"
export * from "./orderSetting.vue?vue&type=script&lang=js&"
import style0 from "./orderSetting.vue?vue&type=style&index=0&id=12ed9f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ed9f1e",
  null
  
)

export default component.exports